export default __webpack_public_path__ + "static/media/favorite.998aa17e.svg";